import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useApi } from "../../lib/useApi";
import { Loader, ErrorState, PageHeader } from "../../components/common/States";
import CompanySearch from "../../components/feedback/CompanySearch";
import FeedbackForm from "../../components/feedback/FeedbackForm";
import { RatingSummary } from "../public/CompanyProfile";

const Compose = ({ slug }) => {
  const { data, loading, error } = useApi(`/public/companies/${slug}`);
  if (loading) return <Loader />;
  if (error) return <ErrorState message={error} />;
  return (
    <div>
      <Link to="/mon-espace/deposer" className="mb-4 inline-flex items-center gap-1 text-sm text-slate-500 hover:text-slate-900" data-testid="user-give-back"><ArrowLeft className="h-4 w-4" />Changer d'organisation</Link>
      <PageHeader eyebrow="Déposer un feedback" title={data.company.name} description={`${data.company.sector} · ${data.company.city}, ${data.company.country}`} />
      <div className="mb-4"><RatingSummary company={data.company} /></div>
      <div className="max-w-3xl"><FeedbackForm company={data.company} agencies={data.agencies} services={data.services} source="user_space" /></div>
    </div>
  );
};

export default function UserGiveFeedback() {
  const { slug } = useParams();
  if (slug) return <Compose slug={slug} />;
  return (
    <div>
      <PageHeader eyebrow="Déposer un feedback" title="Rechercher une organisation" description="Choisissez l'organisation concernée par votre avis, suggestion ou réclamation." />
      <CompanySearch linkFor={(c) => `/mon-espace/deposer/${c.slug}`} />
    </div>
  );
}
